import React from 'react';

import './FollowedChannelList.scss';
import { link } from '../../helpers/link';
import icons from '../../shared/assets/icons';
import BackButton from '../BackButton/BackButton.jsx';

const { Subscribe } = icons;

export default function FollowedChannelList(props) {
  return (
    <section id="followedChannelList">
      <BackButton />

      <ul>
        {props.user.channelSubscriptions.map(({ channel }) => (
          <li className="followedChannelList_item" key={channel.id}>
            <img src={channel.imageUrl} alt="channel-image" />

            <p>
              {link(
                <span>{channel.displayName}</span>,
                `/channels/${channel.uri}`
              )}
            </p>

            <button onClick={() => unsubscribe(channel)}>
              <Subscribe /> Geabonneerd
            </button>
          </li>
        ))}
      </ul>
    </section>
  );

  function unsubscribe(channel) {
    props.unsubscribeChannel({
      variables: {
        channelUri: channel.uri
      }
    });
  }
}
